import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import {MenuItem} from '@components';
import {LOCAL_STORAGE_USER_LOGIN_INFO, USER_ROLE} from "@app/constants/Common";

export const MENU = [
    {
        name: 'menusidebar.label.dashboard',
        path: '/',
        icon: 'fas fa-tachometer-alt'
    },
    {
        name: 'menusidebar.label.notifications',
        path: '/notifications',
        icon: 'fas fa-bell',
    },
    {
        name: 'menusidebar.label.candidateInput',
        children: [
            {
                name: 'menusidebar.label.extractCV',
                path: '/candidate/cv/upload'
            },
            {
                name: 'menusidebar.label.uploadExcel',
                path: '/candidate/excel/upload'
            },
            {
                name: 'menusidebar.label.extractPartInfo',
                path: '/person/create'
            },
        ]
    },
    {
        name: 'menusidebar.label.candidateManager',
        children: [
            {
                name: 'menusidebar.label.candidates',
                path: '/candidate/list'
            },
            {
                name: 'menusidebar.label.candidateGroups',
                path: '/saved-list'
            }
        ]
    },
    {
        name: 'menusidebar.label.employerManager',
        roles: [USER_ROLE.ADMIN],
        children: [
            {
                name: 'menusidebar.label.employerList',
                path: '/employer/list'
            },
            {
                name: 'menusidebar.label.addEmployer',
                path: '/employer/add'
            },
        ]
    },
    {
        name: 'menusidebar.label.jobManager',
        children: [
            {
                name: 'menusidebar.label.jobList',
                path: '/job/list'
            },
            {
                name: 'menusidebar.label.jobPipeLine',
                path: '/job/pipeline/list',
            },
            {
                name: 'menusidebar.label.runJobList',
                path: '/run-job/list'
            }
        ]
    },
    {
        name: 'menusidebar.label.dvtjcuvManager',
        roles: [USER_ROLE.ADMIN],
        children: [
            // {
            //     name: 'menusidebar.label.jobList',
            //     path: '/job/list'
            // },
            // {
            //     name: 'menusidebar.label.jobPipeLine',
            //     path: '/job/pipeline/list',
            // },

            {
                name: 'menusidebar.label.dvtjcuvList',
                path: '/dvtjcuv/list',
            },
            {
                name: 'menusidebar.label.runDvtjcuvAcquireCdds',
                path: '/dvtjcuv/acquire-cdd',
            },
            {
                name: 'menusidebar.label.runDvtjcuvConnectCddEmp',
                path: '/dvtjcuv/connect-cdd-emp',
            },
            {
                name: 'menusidebar.label.cddOpenAndNotSddv',
                path: '/dvtjcuv/cdd-open-and-not-sddv',
            },
            {
                name: 'menusidebar.label.cddSDDVList',
                path: '/dvtjcuv/cdd-sddv'
            },            {
                name: 'menusidebar.label.workWithRecs',
                path: '/dvtjcuv/work-with-recs',
            },
        ]
    },
    {
        name: 'menusidebar.label.mailManager',
        children: [
            {
                name: 'menusidebar.label.yourEmails',
                path: '/mail/your-mail/list'
            },
            {
                name: 'menusidebar.label.signatureTemplate',
                path: '/mail/signature-temp/list'
            },
            {
                name: 'menusidebar.label.inviteJobTemplate',
                path: '/mail/invite-job-temp/list'
            },
            {
                name: 'menusidebar.label.dvtjcuvTemplate',
                path: '/mail/dvtjcuv-temp/list'
            },
        ]
    },
    {
        name: 'menusidebar.label.userManagement',
        roles: [USER_ROLE.ADMIN],
        children: [
            {
                name: 'menusidebar.label.memberList',
                path: '/member/list'
            },
        ]
    },
    {
        name: 'menusidebar.label.dictManager',
        roles: [USER_ROLE.ADMIN],
        children: [
            {
                name: 'menusidebar.label.extractContentDict',
                path: '/extract-content-dict/list'
            },
            {
                name: 'menusidebar.label.extractKeywordDict',
                path: '/extract-keyword-dict/list'
            },
            {
                name: 'menusidebar.label.standardDict',
                path: '/standard-dict/list'
            },
        ]
    },
    {
        name: 'menusidebar.label.accessLogManager',
        roles: [USER_ROLE.ADMIN],
        children: [
            {
                name: 'menusidebar.label.accessLogHistory',
                path: '/accesslog-history'
            },
        ]
    }
];

const MenuSidebar = () => {
    const user = useSelector((state) => state.auth.currentUser);
    const [userLoginInfo, setUserLoginInfo] = useState({});

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    return (
        <aside className="main-sidebar sidebar-dark-primary elevation-4">
            <Link to="/" className="brand-link">
                <img
                    src="/static/img/logo.png"
                    alt="GOPA Logo"
                    className="brand-image img-circle elevation-3"
                    style={{opacity: '.8'}}
                />
                <span className="brand-text font-weight-light">GOPA CRM</span>
            </Link>
            <div className="sidebar">
                {/*<div className="user-panel mt-3 pb-3 mb-3 d-flex">*/}
                {/*    <div className="image">*/}
                {/*        <img*/}
                {/*            src={user.picture || '/static/img/default-profile.png'}*/}
                {/*            className="img-circle elevation-2"*/}
                {/*            alt="User"*/}
                {/*        />*/}
                {/*    </div>*/}
                {/*    <div className="info">*/}
                {/*        <Link to="/profile" className="d-block">*/}
                {/*            {user.email}*/}
                {/*        </Link>*/}
                {/*    </div>*/}
                {/*</div>*/}
                <nav className="mt-2" style={{overflowY: 'hidden'}}>
                    <ul
                        className="nav nav-pills nav-sidebar flex-column"
                        role="menu"
                    >
                        {MENU.map((menuItem) => {
                            if (userLoginInfo.is_superuser || !userLoginInfo.groups_id || !menuItem.roles
                                || menuItem.roles.includes(userLoginInfo.groups_id)) {
                                return <MenuItem key={menuItem.name} menuItem={menuItem} />
                            }
                            return ""
                        })}
                    </ul>
                </nav>
            </div>
        </aside>
    );
};

export default MenuSidebar;
